module.exports = __webpack_public_path__ + "img/first-footer-icon.4a4271c7.svg";